<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-btn
          outlined
          color="primary"
          class="ma-2"
          @click="openReport('daySummary')"
        >
          <v-icon left small>mdi-chart-line</v-icon>
          Sale Summary
        </v-btn>

        <v-btn
          outlined
          color="primary"
          class="ma-2"
          @click="openReport('payment')"
        >
          <v-icon left small>mdi-credit-card</v-icon>
          Payments
        </v-btn>

        <v-btn
          outlined
          color="indigo"
          class="ma-2"
          @click="openReport('quarterlyTaxes')"
        >
          <v-icon left small>mdi-finance</v-icon>
          Quarterly Taxes
        </v-btn>

        <v-btn
          outlined
          color="pink"
          class="ma-2"
          @click="openReport('monthlyTaxes')"
        >
          <v-icon left small>mdi-calendar-month</v-icon>
          Monthly Taxes
        </v-btn>

        <v-btn
          outlined
          color="orange"
          class="ma-2"
          @click="pushToReport('reports-timeClock-list')"
        >
          <v-icon left small>mdi-timer</v-icon>
          Time Clock
        </v-btn>

        <v-btn
          outlined
          color="primary"
          class="ma-2"
          @click="openSerializedInventory"
        >
          <v-icon left small>mdi-barcode-scan</v-icon>
          Serialized Inventory
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { embeddedMobileApp } from "@/mobile/runtime";

export default {
  name: "location-reports",
  props: ["LocationId", "location", "Time"],
  computed: {
    ...mapGetters("reportView", ["getReportName"]),
  },
  methods: {
    ...mapActions("reportView", ["setDateSelector", "setReportName"]),

    pushToReport(val) {
      this.$router.push({
        name: val,
        params: {
          LocationId: this.LocationId,
          Location: this.location,
        },
      });
    },

    openReport(val) {
      const routeData = this.$router.resolve({
        path: `/reportview/${val}/date?start=${this.Time.start}&end=${this.Time.end}&range=${this.Time.range}&LocationId=${this.LocationId}`,
        params: { location: this.location },
      });
      if (embeddedMobileApp.active) {
        this.$router.push(routeData.route.fullPath).catch(() => {});
        return;
      }
      window.open(routeData.href, "_blank");
    },

    openSerializedInventory() {
      const routeData = this.$router.resolve({
        name: "serialized-inventory",
        query: { LocationId: this.LocationId },
      });
      if (embeddedMobileApp.active) {
        this.$router.push(routeData.route.fullPath).catch(() => {});
        return;
      }
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
